
import Model from '../../models/model';
import strings from '../../Globalization';

const chartTitles = new Map([
	['CycleStatus', 'CycleStatus'],
	['OperatorName', 'Operator'],
	['CycleName', 'CycleType'],
	['EquipmentName', 'EquipmentName'],
	['EquipmentTypeName', 'EquipmentType'],
	['CycleActionStatus', 'ReviewStatus'],
	['Month', 'Month'],
	['Day', 'Day'],
	['Week', 'Week'],
	['ErrorCode', 'FaultCode']
]);
const getChartTitle = (values) => {
	const isStacked = values?.selectedChartType === 'Stacked';
	const initialGroup = isStacked ? values?.stackedChartGroup1 || values?.stackedChartGroup2 : values?.selectedChartGroup;
	let defaultTitleValue = strings.CycleGroupByHeader;
	let chartTitle = strings[chartTitles.get(initialGroup)];
	if (isStacked) {
		let otherStackedGroupSelected;
		if (values.stackedChartGroup1) {
			otherStackedGroupSelected = strings[chartTitles.get(values.stackedChartGroup1)];
			if (otherStackedGroupSelected) {
				chartTitle = `${defaultTitleValue} ${otherStackedGroupSelected}`;
			} else {
				chartTitle = `${defaultTitleValue} ${chartTitle}`;
			}
		}
		if (values.stackedChartGroup2) {
			otherStackedGroupSelected = strings[chartTitles.get(values.stackedChartGroup2)];
			if (otherStackedGroupSelected) {
				chartTitle = `${chartTitle} ${strings.CycleGroupByThen} ${otherStackedGroupSelected}`;
			} else {
				chartTitle = `${defaultTitleValue} ${chartTitle}`;
			}
		}

	} else {
		chartTitle = `${defaultTitleValue} ${chartTitle}`;
	}
	return chartTitle;
};

const model = new Model({
	name: 'Graph',
	combos: [],

	initialValues: {
		selectedChartValue: 'RecordCount',
		showOnEquipmentScreen: true,
		chartTitle: ''
	},
	columns: [
		{
			field: 'chartIndex',
			header: 'chartIndex',
			type: 'number',
			hideLabel: true,
			customizeInput: ({ inputProps: { formik } }) => <input type={'hidden'} value={formik.values?.chartIndex}></input>
		},
		{
			field: 'selectedChartType',
			header: 'ChartTypeTitle',
			lookup: 'ChartType',
			inlineLabelSize: 12,
			required: true
		},

		{
			field: 'selectedChartGroup',
			header: 'GroupBy',
			lookup: 'ChartGroup',
			inlineLabelSize: 12,
			onChange: ({ values, formik }) => {
				const chartTitle = getChartTitle(values);
				formik.setFieldValue('chartTitle', chartTitle);
			},
			inputWhen: ({ formik }) => {
				return formik.values.selectedChartType !== 'Stacked';
			}
		},
		{
			field: 'stackedChartGroup1',
			header: 'GroupBy',
			lookup: 'ChartGroup',
			inlineLabelSize: 12,
			disableClearable: true,
			onChange: ({ formik, values }) => {
				const chartTitle = getChartTitle(values);
				formik.setFieldValue('chartTitle', chartTitle);
			},
			inputWhen: [['selectedChartType', 'Stacked']]
		},
		{
			field: 'stackedChartGroup2',
			header: 'Then',
			lookup: 'ChartGroup',
			inlineLabelSize: 12,
			disableClearable: true,
			onChange: ({ formik, values }) => {
				const chartTitle = getChartTitle(values);
				formik.setFieldValue('chartTitle', chartTitle);
			},
			inputWhen: [['selectedChartType', 'Stacked']]
		},

		{
			field: 'chartTitle',
			header: 'ChartTitle',
			required: true,
			inlineLabelSize: 12
		}
	]
});

export default model.createFormDialog();
